import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import ResourceComponent from './ResourceComponent';
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class Resources extends Component {
	constructor(props) {
		super(props)
    	this.state = {
            snackbarIsOpen: false,
            uploadDisableButton: true,
            saveButtonDisable: false,
    		uploadFormOpen: false,
    		addFormOpen: false,
    		fetchData: {
    			parentDropDown: [],
    			parentId: '',
                resourceDetails: []
    		},
    		data:{
    			resourceName: '',
    			resourceLink: '',
    			resourceAuthor: '',
    			resourceDescription: EditorState.createEmpty(),
    			taxonomyComboDropDown: [],
                standardComboDropDown: [],
    			languageId: '',
    			languageDropDown: [],
                levelDropDown: [],
                levelId: '',
                trackDropDown: [],
                buzzwordDropDown: [],
                resourceDropDown: [],
                complexityDropDown: [],
                complexityId: '',
                centaRating: '',
                centaRatingDropDown: [],
                resourceClass: '',
                resourceCustomId: '',
                listingSequence: '',
                imgLink: '',
                active: 1,
                blogId: '',
                blogIdDropDown: [],
                linkBlogResourceType: '',
                blogLinkSelectedOption: 1
    		},
    		fileError: '',
    		errorMsg: '',
            fetchErrorMessage: '',
    		addedTaxonomyParent: [],
            addedStandard: [],
            addedTracks: [],
            addedBuzzwords: [],
            addedResource: [],
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()
        this.props.history.push(`/portal/app/admin/learning_taxonomies`)
    }

    handleStandaloneResources = (e) => {
        e.preventDefault()
        this.props.history.push(`/portal/app/admin/standalone_resources`)
    }

    handleFetchParentChange = (event) => {
        let fetchData = Object.assign({}, this.state.fetchData)
        fetchData.parentId = event.target.value
        this.setState({fetchData: fetchData})
    }

    handleResourceNameChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.resourceName = event.target.value
        this.setState({data: data}) 
    }

    handleResourceCustomIdChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.resourceCustomId = event.target.value
        this.setState({data: data}) 
    }

    handleResourceAuthorChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.resourceAuthor = event.target.value
        this.setState({data: data}) 
    }

    handleResourceDescChange: Function = (editorState) => {
        let data = Object.assign({}, this.state.data)
        data.resourceDescription = editorState
        this.setState({data: data});
    }

    handleResourceLinkChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.resourceLink = event.target.value
        data.linkBlogResourceType = "link"
        this.setState({data: data}) 
    }

    handleResourceListingSequenceChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.listingSequence = event.target.value
        this.setState({data: data})
    }

    handleResourceImageLinkChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.imgLink = event.target.value
        this.setState({data: data})
    }

    handleResourceActiveChange = evt => {
        let data = Object.assign({}, this.state.data)
        data.active = evt.target.value
        this.setState({data: data})
    }

    handleCentaRatingDropDown = (e) => {
        let data = Object.assign({}, this.state.data)

        for (var i = 1; i < 6; i++) {
            var a = {}
            a["id"] = i
            if (i === 1) {
                a["name"] = i + ' Star'
            }
            else {
                a["name"] = i + ' Stars'
            }
            data.centaRatingDropDown.push(a)
        }
        this.setState({data: data})
    }

    handleLanguages = (e) => {
    	let data = Object.assign({}, this.state.data)
        let url = 'admin/learning_taxonomy/languages'
        let backwardResource = 'admin/learning_resource/render_resources/association_details'
    	return api.getResponse(this.props.user.accessToken, url)
    	.then((result) => {
    		data.languageDropDown = result
    		return api.getResponse(this.props.user.accessToken, backwardResource)
    	}).then((result) => {
            if (result.status === 'success'){
                data.resourceDropDown = result.data
                this.setState({data: data})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'There seems to be a problem disabling the resource.' })
        })
    }

    handleLanguageChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.languageId = event.target.value
        this.setState({data: data})
    }

    handleUploadForm = (e) => {
    	this.handleLanguages(e)
    	this.setState({uploadFormOpen: true, addFormOpen: false, fetchErrorMessage: ''})
    }

    handleAddForm = (e) => {
    	this.handleLanguages(e)
    	this.setState({addFormOpen: true, uploadFormOpen: false, fetchErrorMessage: ''})
    }

    handleCancelForm = (e) => {
        let data = Object.assign({}, this.state.data)

        data.resourceName = ''
        data.resourceLink = ''
        data.resourceAuthor = ''
        data.resourceDescription = ''
        data.languageId = ''
        data.levelId = ''
        data.resourceClass = ''
        data.resourceCustomId = ''
        data.listingSequence = ''
        data.imgLink = ''
        data.active = ''
        data.blogId = ''
    	this.setState({addFormOpen: false, uploadFormOpen: false, fileError: '', errorMsg: '', data: data, addedTaxonomyParent: [], addedTracks: [], addedBuzzwords: [], addedResource: [], addedStandard: [], saveButtonDisable: false})
    }

    handleResourceSave = (e) => {
    	e.preventDefault()
        this.setState({saveButtonDisable: true})

        let htmlText = stateToHTML(this.state.data.resourceDescription.getCurrentContent())

        if (htmlText.length > 5000){
            return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', modifyDisable: false})
        }

        if (this.state.addFormOpen === true) {
            if ((this.state.data.resourceLink === '') && (this.state.data.blogId === '')) {
                return this.setState({errorMsg: 'Please enter the link/Blog of the resource before adding a resource.', saveButtonDisable: false})
            }

            if ((this.state.data.resourceLink !== '') && (this.state.data.blogId !== '')){
                console.log(this.state.data)
                return this.setState({errorMsg: 'Please select either Blog or Link. ', saveButtonDisable: false})
            }

            if ((this.state.data.resourcelink !== '') && (this.state.data.resourceLink.length > 750)) {
                return this.setState({errorMsg: 'The link of the resource is very large. Please contact the Admin.', saveButtonDisable: false})
            }
        }

        if ((this.state.data.resourceName === '') || (this.state.data.languageId === '') || (this.state.data.complexityId === '') || (this.state.data.centaRating === '') || (this.state.addedTaxonomyParent.length === 0) || (this.state.data.resourceCustomId === '') || (this.state.data.imgLink === '') || (this.state.data.listingSequnce === '')){
            return this.setState({errorMsg: 'Please enter the necessary details before updating the resource.', saveButtonDisable: false})
        }

    	let data = Object.assign({}, this.state.data)
    	const formData = new FormData(e.target);

        var myStringArray = this.state.addedTaxonomyParent;
        var arrayLength = myStringArray.length;
        let selectedTaxonomyString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedTaxonomyString.push(parseInt(myStringArray[i].value))
        }

        var myStandardArray = this.state.addedStandard;
        var standardLength = myStandardArray.length;
        for (var i = 0; i < standardLength; i++) {
            selectedTaxonomyString.push(parseInt(myStandardArray[i].value))
        }

        var trackArray = this.state.addedTracks;
        var trackLength = trackArray.length;
        let selectedTrackString = []
        for (var z = 0; z < trackLength; z++) {
            selectedTrackString.push(parseInt(trackArray[z].value))
        }

        var buzzwordArray = this.state.addedBuzzwords;
        var buzzwordLength = buzzwordArray.length;
        let selectedBuzzwordString = []
        for (var y = 0; y < buzzwordLength; y++) {
            selectedBuzzwordString.push(parseInt(buzzwordArray[y].value))
        }

        var resourceArray = this.state.addedResource;
        var resourceLength = resourceArray.length;
        let selectedResourceString = []
        for (var x = 0; x < resourceLength; x++) {
            selectedResourceString.push(parseInt(resourceArray[x].value))
        }

        formData.append("resourcedesc", htmlText)
        formData.append("selected_taxonomies", selectedTaxonomyString)
        formData.append("test_track_id", selectedTrackString)
        formData.append("buzzwords", selectedBuzzwordString)
        formData.append("selected_resources", selectedResourceString)
    	api.adminAddLearningResource(this.props.user.accessToken, formData)
    	.then((result) => {
    		if (result.status === 'success') {
    			data.resourceName = ''
    			data.resourceLink = ''
    			data.resourceAuthor = ''
    			data.resourceDescription = ''
    			data.languageId = ''
                data.levelId = ''
                this.handleCancelForm(e)
    			this.setState({snackbarIsOpen: !this.state.snackbarIsOpen, saveButtonDisable: false})
    		}
            else {
                this.setState({saveButtonDisable: false})
            }
    	})
    }

    handleResourceFetch = (e) => {
        if (this.state.fetchData.parentId === '') {
            return this.setState({fetchErrorMessage: 'Please select a theme to fetch the resource', addFormOpen: false, uploadFormOpen: false})
        }
        let fetchData = Object.assign({}, this.state.fetchData)
        let url = `learning_resource/${this.state.fetchData.parentId}`
        api.getResponse(this.props.user.accessToken, url)
        .then((result) => {
            fetchData.resourceDetails = result.data
            this.setState({fetchData: fetchData, errorMsg: '', addFormOpen: false, uploadFormOpen: false, fetchErrorMessage: ''})
        })
    }

    handleTaxonomyParentChange = (option) => {
        this.handleFetchAssociatedStandards(option)
        this.setState(state => {
            return {
                addedStandard : [],
                addedTaxonomyParent : option
            };
        });
    }

    handleFetchAssociatedStandards = (option) => {
        let selectedAspect = []
        let data = Object.assign({}, this.state.data)

        var myAspectArray = option;
        var aspectLength = myAspectArray.length;
        for (var i = 0; i < aspectLength; i++) {
            selectedAspect.push(parseInt(myAspectArray[i].value))
        }

        let value = {
            'selected_aspect' : selectedAspect
        }

        api.getAssociatedStandards(this.props.user.accessToken, value)
        .then((result) => {
            console.log(result.data)
            if (result.status === 'success') {
                data.standardComboDropDown = result.data
                this.setState({data:data})
            }
        })
    }

    handleStandardChange = (option) => {
        this.setState(state => {
            return {
                addedStandard : option
            };
        });
    }

    handleResAssociatedTracks = (option) => {
        this.setState(state => {
            return {
                addedTracks : option
            };
        });
    }

    handleBuzzwords = (option) => {
        this.setState(state => {
            return {
                addedBuzzwords : option
            };
        });
    }

    handleBackwardLink = (option) => {
        this.setState(state => {
            return {
                addedResource : option
            };
        });
    }

    componentDidMount() {
    	let fetchData = Object.assign({}, this.state.fetchData)
    	let data = Object.assign({}, this.state.data)

        let newSectionType = 3
        let standardType = 4
        let fetchStandardDropDown =  `admin/taxonomy_details/${standardType}`
        let fetchDropDown =  `learning_taxonomy/${newSectionType}`
        let taxonomyDropdown = `admin/taxonomy_details/${newSectionType}`
        let getBuzzwords = 'buzzword'
        let complexity = 'admin/learning_resource/complexity'
        let blogUrl = '/admin/lr/get/all/posts'

    	return api.getResponse(this.props.user.accessToken, fetchDropDown)
    	.then((result) => {
    		fetchData.parentDropDown = result
    		api.getResponse(this.props.user.accessToken, taxonomyDropdown)
            .then((result) => {
                if (result.status === 'success') {
                    data.taxonomyComboDropDown = result.data
                    api.adminResourceLevelsBox(this.props.user.accessToken)
                    .then((result) => {
                        data.levelDropDown = result.data
                        api.adminResourceTracksBox(this.props.user.accessToken)
                        .then((result) => {
                            data.trackDropDown = result.data
                            this.handleCentaRatingDropDown()
                            api.getResponse(this.props.user.accessToken, getBuzzwords)
                            .then((result) => {
                                if (result.status === 'success'){
                                    data.buzzwordDropDown = result.data
                                    api.getResponse(this.props.user.accessToken, complexity)
                                    .then((result) => {
                                        data.complexityDropDown = result
                                        api.getResponse(this.props.user.accessToken, blogUrl)
                                        .then((result) => {
                                            if(result.status === 'success'){
                                                data.blogIdDropDown = result.data
                                                this.setState({data: data, specificFormOpen: true, fetchData: fetchData})
                                            }
                                        })
                                    })           
                                }    
                            })
                        })
                    })
                }
            })
    	})
    }

    handleCentaRatingsChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.centaRating = event.target.value
        this.setState({data: data})
    }

    handleResourceClassChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.resourceClass = event.target.value
        this.setState({data: data})
    }

    handleLevelsChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.levelId = event.target.value
        this.setState({data: data})
    }

    handleComplexityChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.complexityId = event.target.value
        this.setState({data: data})
    }

    handleListingSequenceChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.listingSequence = event.target.value
        this.setState({data: data})
    }

    handleBlogLinkResourceChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.blogLinkSelectedOption = event.target.value
        data.linkBlogResourceType = ''
        this.setState({data: data})
    }

    handleImageLinkChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.imgLink = event.target.value
        this.setState({data: data})
    }

    handleBlogIdChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.isLinkResourceDisabled == true
        data.blogId = event.target.value
        data.linkBlogResourceType = "blog"
        this.setState({data:data})
    }

    validateUpload = (event) =>{
        if (event.target.files[0] === undefined){
            return this.setState({uploadDisableButton: true})
        }
        let file_name = event.target.files[0].name;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

        if (extension === "pdf"){
            this.setState({uploadDisableButton: false, fileError: ''})
        }
        else{
            this.setState({uploadDisableButton: true, fileError: 'Invalid File Format. Upload PDF file only.'})
        }
    }

	render() {
        const { resourceDescription } = this.state.data;
		let handleUploadForm = this.handleUploadForm
		let handleAddForm = this.handleAddForm
		let handleCancelForm = this.handleCancelForm
		let handleResourceSave = this.handleResourceSave
        let handleResourceFetch = this.handleResourceFetch
        let handleBackAction = this.handleBackAction
        let resetStandard = this.resetStandard
        let handleStandaloneResources = this.handleStandaloneResources
		let addUploadForm
		let linkField, hiddenComponent, blogField
		let docField
        let individualResource, uploadButtonComponent, blogResourceComponent

        let activeComponent = (
        <GridCell span = "12">
          <Select
            name = 'active'
            onChange={this.handleResourceActiveChange} 
            value={this.state.data.active}
          >
            <option value = "1">Active</option>
            <option value = "0">Inactive</option>
          </Select>
        </GridCell>
        )
        if (this.state.uploadFormOpen === false){
        blogResourceComponent = (
                    <GridCell span = "12">
                        <Select
                        name = 'blogLinkSelectedOption'
                        onChange={this.handleBlogLinkResourceChange} 
                        value={this.state.data.blogLinkSelectedOption}
                        placeholder = "Please choose the Resource Type"
                        >
                        <option value = "1">Link</option>
                        <option value = "0">Blog</option>
                      </Select>
                    </GridCell>
            )}

        let Snackbarcomponent =(
            <Snackbar
                show={this.state.snackbarIsOpen}
                onHide={evt => this.setState({snackbarIsOpen: false})}
                message="Resource successfully added/uploaded"
            />
        )

        if (this.state.fetchData.resourceDetails.length > 0) {
            individualResource = (
                <Grid className="opportunity-list-item">
                    {this.state.fetchData.resourceDetails.map(function(resource){
                        let uniq = Math.random() * resource.id 
                        return (
                            <GridCell span = "12" key = {uniq}>
                                <Card style={{padding: '0px'}}>
                                    <ResourceComponent resourceId = {resource.id}
                                        resourceName = {resource.name}
                                        resourceAuthor = {resource.author}
                                        resourceDescription = {resource.description}
                                        shortDescription = {resource.short_description}
                                        resourceLink = {resource.resource_link}
                                        resourceLanguage = {resource.language}
                                        languageId = {resource.language_id}
                                        resourceComplexity = {resource.complexity}
                                        complexityId = {resource.complexity_id}
                                        resourceCreationDate = {resource.created_at}
                                        resourceStatus = {resource.active}
                                        resourceType = {resource.resource_type}
                                        buzzwords = {resource.buzzwords}
                                        centaRating = {resource.centa_rating}
                                        ratings = {resource.rating}
                                        resourceClass = {resource.resource_class}
                                        resourceCustomId = {resource.custom_id}
                                        onHandleResourceFetch = {handleResourceFetch}
                                        parentTags = {resource.parent_tags}
                                        isAdmin = {true}
                                        bookmarkFeature = {false} 
                                        archiveFeature = {false}
                                        listingSequence = {resource.listing_sequence}
                                        imgLink = {resource.img_link}
                                        active = {resource.active}
                                        blogId = {resource.blog_id}
                                    />
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }
        else {
            individualResource = (
                <Grid className="opportunity-list-item">
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography> There are currently no resources for this theme. Please add/upload a resource to make them available.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }

		if (this.state.uploadFormOpen === false){
            if(this.state.data.blogLinkSelectedOption == 1){
			linkField = (
                <div>
    				<GridCell span="6">
    	                <TextField fullwidth className = 'test_input' label="Link of the Resource" autoComplete="off"  name="resourcelink" defaultValue = {this.state.data.resourceLink} onChange = {this.handleResourceLinkChange} diabled = {this.state.data.isBlogResourceDisabled} style={{ height: '140%' }}/>
    	            </GridCell>
                </div>)
            }
            else
            {
            blogField = (
                <div>
                     <GridCell span="6">
                        <Select
                            name="blog_id"
                            onChange={this.handleBlogIdChange}
                            className="select-component"
                            placeholder="--Select Blog--">
                            {this.state.data.blogIdDropDown.map(blog => (
                                <option key={blog.id} value={blog.id} data-name={blog.title}>
                                    {blog.title}
                                </option>
                            ))}
                        </Select>
                    </GridCell>
                </div>
	       	)}
            hiddenComponent = (
                <div key = {this.state.data.linkBlogResourceType}>
                    <TextField autoComplete="off" name="resourcetype" hidden  value={this.state.data.linkBlogResourceType}/>
                </div>
            )
		}

		if (this.state.addFormOpen === false){
			docField = (
				<div>
    				<br />
    				<GridCell span="12">
                        <Typography>Please add the resource document here:  </Typography><input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
    	            </GridCell>
	            </div>
	       	)
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden name="resourcetype"  value="document"/>
                </div>
            )
		}

        if (this.state.saveButtonDisable === false) {
            if ((this.state.uploadDisableButton === true) && (this.state.uploadFormOpen === true)){
                uploadButtonComponent = (
                    <GridCell span = "4">
                        <Button raised disabled style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
            else{
                uploadButtonComponent = (
                    <GridCell span = "4">
                        <Button raised style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
        }
        else {
            uploadButtonComponent = (
                <GridCell span = "4">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }

		if ((this.state.uploadFormOpen === true) || (this.state.addFormOpen === true)) {
			addUploadForm = (
				<div>
					<Card style={{padding: '25px'}}>
						<div>
							<form onSubmit= {((e) => this.handleResourceSave(e))} style={{ width: '100%' }}>
								<GridCell span="12">
                    				<TextField fullwidth label="Name of the Resource" autoComplete="off"  name="resourcename" defaultValue = {this.state.data.resourceName} onChange = {this.handleResourceNameChange} style={{ height: '140%' }}/>
                				</GridCell>
		                        {docField}
                                {blogResourceComponent}
                                {linkField}
                                {blogField}
                            <Grid className="opportunity-list-item">
  		                        <GridCell span="8">
  		                            <TextField fullwidth label="Author" name="resourceauthor" defaultValue = {this.state.data.resourceAuthor} onChange={this.handleResourceAuthorChange} style={{ height: '140%' }}/>
  		                        </GridCell>
                              <GridCell span="4">
                                  <TextField fullwidth label="Custom ID" autoComplete="off"  name="custom_id" defaultValue = {this.state.data.resourceCustomId} onChange = {this.handleResourceCustomIdChange} style={{ height: '140%' }}/>
                              </GridCell>
                              <GridCell span="6">
                                <TextField fullwidth label="Listing Sequence" autoComplete="off"  name="listing_sequence" type= "number" defaultValue = {this.state.data.listingSequence} onChange = {this.handleResourceListingSequenceChange} style={{ height: '140%' }}/>
                              </GridCell>
                              <GridCell span="6">
                                <TextField fullwidth label="Image Link" autoComplete="off"  name="img_link" defaultValue = {this.state.data.imgLink} onChange = {this.handleResourceImageLinkChange} style={{ height: '140%' }}/>
                              </GridCell>
                              <GridCell span ="12">
                              {activeComponent}
                              </GridCell>
                            </Grid>

		                        <br />
		                        <GridCell span="12">
		                            <div className = "description-panel" >
                                        <Editor
                                            editorState={resourceDescription}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.handleResourceDescChange}
                                            toolbar={{
                                                options:['inline', 'list' ],
                                                link: { inDropdown: true },
                                                inline:
                                                    {
                                                        options:['bold', 'italic', 'underline']
                                                    },
                                            }}
                                        />
                                    </div>
		                        </GridCell>
                                <Grid className="opportunity-list-item">
    		                        <GridCell span = "6">
    			                        <Select
    			                            name="languagesection"
    			                            onChange={this.handleLanguageChange}
    			                            defaultValue={this.state.data.languageId}
    			                            className="select-component"
    			                            placeholder="--Select the Language--">
    			                            {this.state.data.languageDropDown.map(list => (
    			                                <option key={list.id} value={list.id} data-name={list.name}>
    			                                    {list.name}
    			                                </option>
    			                            ))}
    			                        </Select>
    			                    </GridCell>
                                    <GridCell span="6">
                                        <Select
                                            name="complexity_id"
                                            onChange={this.handleComplexityChange}
                                            defaultValue={this.state.data.complexityId}
                                            className="select-component"
                                            placeholder="--Select Complexity--">
                                            {this.state.data.complexityDropDown.map(complexity => (
                                                <option key={complexity.id} value={complexity.id} data-name={complexity.name}>
                                                    {complexity.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </GridCell>
                                </Grid>
                                <Grid className="opportunity-list-item">
                                    <GridCell span="4">
                                        <Select
                                            name="resource_class"
                                            onChange={this.handleResourceClassChange} 
                                            value={this.state.data.resourceClass}
                                            defaultValue={this.state.data.resourceClass}
                                            className="select-component" >

                                            <option> --Internal Vs External-- </option>
                                            <option value="internal">Internal</option>
                                            <option value="external">External</option>
                                                    
                                        </Select>
                                    </GridCell>
                                    <GridCell span="4">
                                        <Select
                                            name="centa_rating"
                                            onChange={this.handleCentaRatingsChange}
                                            defaultValue={this.state.data.centaRating}
                                            className="select-component"
                                            placeholder="--Select CENTA Rating--">
                                            {this.state.data.centaRatingDropDown.map(rating => (
                                                <option key={rating.id} value={rating.id} data-name={rating.name}>
                                                    {rating.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </GridCell>
                                    <GridCell span="4">
                                        <Select
                                            name="level_id"
                                            onChange={this.handleLevelsChange}
                                            defaultValue={this.state.data.levelId}
                                            className="select-component"
                                            placeholder="--Select Level--">
                                            {this.state.data.levelDropDown.map(level => (
                                                <option key={level.value} value={level.value} data-name={level.label}>
                                                    {level.label}
                                                </option>
                                            ))}
                                        </Select>
                                    </GridCell>
                                </Grid>
                                <br />
                                <GridCell span="12">
                                    <Reactsel
                                        name="trackslist"
                                        onChange={this.handleResAssociatedTracks}
                                        defaultValue={this.state.addedTracks}
                                        options={this.state.data.trackDropDown}
                                        placeholder="--Select Track--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <br />
		                        <GridCell span = "12">
		                        	<Reactsel
		                                name="taxonomylist"
		                                onChange={this.handleTaxonomyParentChange}
		                                defaultValue={this.state.addedTaxonomyParent}
		                                options={this.state.data.taxonomyComboDropDown}
		                                placeholder="--Select an Aspect--"
		                                isMulti>
			                        </Reactsel>
		                        </GridCell>
                                <br />
                                <GridCell span = "12">
                                    <Reactsel
                                        name="standardlist"
                                        onChange={this.handleStandardChange}
                                        value={this.state.addedStandard}
                                        options={this.state.data.standardComboDropDown}
                                        placeholder="--Select a Standard--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <br />
                                <GridCell span = "12">
                                    <Reactsel
                                        name="buzzwordslist"
                                        onChange={this.handleBuzzwords}
                                        defaultValue={this.state.addedBuzzwords}
                                        options={this.state.data.buzzwordDropDown}
                                        placeholder="--Select associated Keywords--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <br />
                                <GridCell span = "12">
                                    <Reactsel
                                        name="pre_read_list"
                                        onChange={this.handleBackwardLink}
                                        value={this.state.addedResource}
                                        options={this.state.data.resourceDropDown}
                                        placeholder="--Select Pre-Read Resource--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
		                        <GridCell span = "12">
			                        <Grid>
				                        {uploadButtonComponent}
				                        <GridCell span = "4">
				                        	<Button dense style={{ width: '100%' }} onClick= {((e) => handleCancelForm(e))}>Cancel</Button>
				                        </GridCell>
                                        <GridCell span = "2">
                                            {hiddenComponent}
                                        </GridCell>
                                        <GridCell span = "2">
                                            <TextField autoComplete="off" hidden name="user_resource_id"  defaultValue={0}/>
                                        </GridCell>
			                        </Grid>
		                        </GridCell>
							</form>
							<StatusMessage error_msg = {this.state.fileError} />
                            <StatusMessage error_msg = {this.state.errorMsg} />
						</div>
					</Card>
				</div>
			)
		}

		let resourceFetchForm = (
			<Grid style={{padding: '0px'}}>
                <GridCell span = "8">
                    <Select
                        name="parentSection"
                        onChange={this.handleFetchParentChange}
                        defaultValue={this.state.fetchData.parentId}
                        className="select-component"
                        placeholder="--Select an Aspect--">
                        {this.state.fetchData.parentDropDown.map(list => (
                            <option key={list.id} value={list.id} data-name={list.name}>
                                {list.name}
                            </option>
                        ))}
                    </Select>
                </GridCell>
                <GridCell span = "4">
                    <Button raised style={{ width: '50%' }} onClick= {((e) => handleResourceFetch(e))}>Fetch</Button>
                </GridCell>
            </Grid>
		)
		return (
			<div>
				<Grid>
					<GridCell span = "12">
						<Card style={{padding: '0px'}}>
                            <Grid>
                                <GridCell span="9">
                                    <Typography use="headline5">Resources</Typography>
                                </GridCell>
                                <GridCell span="2">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleStandaloneResources(e))}>Standalone</Button>
                                </GridCell>
                                <GridCell span="1">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                </GridCell>
                            </Grid>
						</Card>
					</GridCell>
                    <GridCell span = "8">
                        {resourceFetchForm}
                    </GridCell>
                    <GridCell span = "2">
                        <Button dense style={{ width: '100%' }} onClick= {((e) => handleUploadForm(e))}>Upload Doc</Button>
                    </GridCell>
                    <GridCell span = "2">
                        <Button dense style={{ width: '100%' }} onClick= {((e) => handleAddForm(e))}>Add Link</Button>
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.fetchErrorMessage} />
                    </GridCell>
                    <GridCell span = "4">
                    </GridCell>
					<GridCell span = "8">
						{addUploadForm}
					</GridCell>
				</Grid>
                {individualResource}
                {Snackbarcomponent}
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Resources);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/Resources.jsx